import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { confirmEmail } from '../../services/auth.service';
import singlePageStyles from '../common/SinglePage.module.scss';
import Layout from '../global/Layout';
import LoadingSpinner from '@solid/shared/ui/LoadingSpinner';
import * as Styled from './EmailConfirmationPage.styles';
import { Button } from '@solid/shared/ui';
import { Trans, useTranslation } from 'react-i18next';
const EmailConfirmationPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useTranslation();
  const { error, isLoading, isSuccess } = useQuery(['email-confirmation', token], () => confirmEmail(token), {
    enabled: !!token,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return (
    <Layout>
      <div className={classNames('wrapper', singlePageStyles.wrapper)}>
        {isLoading && <LoadingSpinner />}
        {error && (
          <>
            <h1>{t('pages.emailConfirmation.error.title')}</h1>
            <p>{t('pages.emailConfirmation.error.text')}</p>
            <div className='notification is-error'>{(error as Error).message}</div>
            <Styled.BtnContainer>
              <Link to='mailto:info@solid-app.de'>
                <Button variant='outlined'>{t('pages.emailConfirmation.error.button')}</Button>
              </Link>
            </Styled.BtnContainer>
          </>
        )}
        {isSuccess && (
          <>
            <h1>{t('pages.emailConfirmation.success.title')}</h1>
            <p>
              <Trans i18nKey='pages.emailConfirmation.success.text' components={{ br: <br /> }} />
            </p>
            <Styled.BtnContainer>
              <Link to='/login'>
                <Button>{t('pages.emailConfirmation.success.button')}</Button>
              </Link>
            </Styled.BtnContainer>
          </>
        )}
        <p></p>
        <div className={singlePageStyles.otherActions}>
          <Link to='/login'>{t('pages.emailConfirmation.otherActions.login')}</Link>
          <Link to='/register'>{t('pages.emailConfirmation.otherActions.register')}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default EmailConfirmationPage;
